import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
};

export function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium whitespace-nowrap">
            {categoryNames[article.category] || article.category}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
        </div>
        <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 line-clamp-2 leading-snug">
          <Link to={`/article/${article.id}`} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">
            {article.title}
          </Link>
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400 whitespace-nowrap">{article.author}</span>
          <Link
            to={`/article/${article.id}`}
            className="text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            阅读全文 <i className="ri-arrow-right-line text-xs ml-1"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}

interface ArticleListProps {
  articles: Article[];
  title: string;
  subtitle?: string;
}

export default function ArticleList({ articles, title, subtitle }: ArticleListProps) {
  return (
    <section className="py-14 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">{subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}